import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import ProductCard from './ProductCard';

const SkeletonCard = () => (
  <div className="bg-white rounded-2xl overflow-hidden border border-[#EDEAF2]">
    <div className="aspect-square shimmer" />
    <div className="p-3.5 space-y-2.5">
      <div className="flex justify-between">
        <div className="h-2.5 shimmer rounded-full w-16" />
        <div className="h-2.5 shimmer rounded-full w-10" />
      </div>
      <div className="h-3.5 shimmer rounded-full w-full" />
      <div className="h-3.5 shimmer rounded-full w-3/4" />
      <div className="h-4 shimmer rounded-full w-1/2" />
      <div className="h-9 shimmer rounded-full w-full mt-2" />
    </div>
  </div>
);

const ProductGrid = ({ products, loading = false, emptyMessage = 'No products found.', cols = 'default' }) => {
  const gridClass = cols === 'default'
    ? 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5'
    : cols;

  if (loading) {
    return (
      <div className={gridClass}>
        {Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)}
      </div>
    );
  }

  if (!products?.length) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center mb-4">
          <MagnifyingGlassIcon className="w-7 h-7 text-primary" aria-hidden="true" />
        </div>
        <p className="display-title text-xl mb-1">No products found</p>
        <p className="text-sm text-ink-soft max-w-xs">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={gridClass}>
      {products.map((p, i) => (
        <ProductCard
          key={p.id}
          product={p}
          style={{ animationDelay: `${i * 40}ms` }}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
